// Typed audit-log endpoint functions. Backed by GET /api/v1/audit-logs.
//
// CHG-1643 / Wave 1 Tier 1 — port of v1 AuditLogs.tsx. Backend handler:
// src/api/app/routers/audit.py. Same scope=org|platform shape as the
// activity-feed sibling.

import { apiClient } from "./client";

export type AuditAction =
  | "create"
  | "update"
  | "delete"
  | "login"
  | "logout"
  | "status_change"
  | "broadcast"
  | "template_edit"
  | "test_send"
  | "rollback"
  | "ai_variant_generated"
  | "ai_variant_approved"
  | "ai_variant_rejected"
  | "wallet_hold_applied"
  | "wallet_hold_released"
  | "wallet_adjusted"
  | "wallet_topup_refunded"
  | "pricing_tier_updated"
  | "manual_invoice_issued"
  | "manual_invoice_paid"
  | string;

export interface AuditLogEntry {
  id: string;
  organization_id: string | null;
  user_id: string | null;
  user_email: string | null;
  action: AuditAction;
  resource_type: string;
  resource_id: string | null;
  description: string | null;
  extra_metadata: Record<string, unknown> | null;
  ip_address: string | null;
  created_at: string;
}

interface AuditEnvelope {
  data: AuditLogEntry[];
  pagination: { page: number; per_page: number; total: number; total_pages: number };
}

export interface ListAuditLogsParams {
  page?: number;
  pageSize?: number;
  action?: AuditAction;
  resource_type?: string;
  user_id?: string;
  search?: string;
  scope?: "org" | "platform";
}

export async function listAuditLogs(
  params: ListAuditLogsParams = {},
): Promise<{ items: AuditLogEntry[]; total: number }> {
  const pageSize = params.pageSize ?? 50;
  const r = await apiClient().get<AuditEnvelope>("/audit-logs", {
    params: {
      page: (params.page ?? 0) + 1,
      per_page: pageSize,
      action: params.action || undefined,
      resource_type: params.resource_type || undefined,
      user_id: params.user_id || undefined,
      search: params.search || undefined,
      scope: params.scope ?? "org",
    },
  });
  return { items: r.data.data, total: r.data.pagination.total };
}

export const auditLogsApi = { listAuditLogs };
